import React from "react";
import { Navigate } from "react-router-dom";
import { useStore } from "../store";

function PrivateRoute({ children }) {
  // store
  const { token } = useStore();

  if (!token) {
    return <Navigate to="/login" />;
  } else {
    return <>{children}</>;
  }
}

export default PrivateRoute;
